
import axios from 'axios';

export const getFindAddress = async (formData) => {

  
    let url =formData[2]+'&addressElements=True';


   return axios.get(url).then(res => {
        return res;
    })
    .catch(err => {
        return err.response
    })
};


export const getFindAddressSecondCall = async (formData) => {

  
    let url =formData +'&addressElements=True';


   return axios.get(url).then(res => {
        return res;
    })
    .catch(err => {
        return err.response
    })
};





